import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {
  faHeart as faHeartSolid,
  faPlay,
  faHome,
  faX,
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
  faCreditCard,
  faTimes,
  faSpinner,
  faCheckCircle,
  faCircleXmark,
  faXmarkCircle,
  faArrowLeft,
  faArrowUp,
  faUser,
  faBars
} from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';

library.add(
  // brands
  faFacebook,
  faInstagram,
  // regular/solid hearts
  faHeartSolid,
  faHeartRegular,
  // solids
  faPlay,
  faHome,
  faX,
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
  faCreditCard,
  faTimes,
  faSpinner,
  faCheckCircle,
  faCircleXmark,
  faXmarkCircle,
  faArrowLeft,
  faArrowUp,
  faUser,
  faBars
);

export default library;
